import { defineAction } from '~/prix'
import { z } from 'zod'
import expression from '~/prix/types/expression'
import { enumerated } from '~/prix/types/enumerated'
import communityGardenListAction from './communityGardenList.action.json' with { type: 'json' }
import { communityGardenObject } from '../communityGardenObject'

export const communityGardenExpression = expression(communityGardenObject.shape)

const communityGardenListDefinition = defineAction({
  ...communityGardenListAction,

  input: z.object({
    filter: communityGardenExpression.nullish(),
    limit: z.number().min(1).max(5000).nullish(),
    offset: z.number().nullish(),
    orderBy: enumerated({
      createdAt: 'Data de criação',
      updatedAt: 'Data de atualização',
      id: 'Identificador',
      title: 'Título',
      area: 'Área',
    }).nullish(),
    order: enumerated({
      ascending: 'Ascendente',
      descending: 'Descendente',
    }).nullish(),
    includeDeleted: z.boolean().nullish(),
  }),
  output: z.object({
    items: z.array(communityGardenObject),
    count: z.number(),
  }),
})

export default communityGardenListDefinition
